export default [
    'desireid',
    'listid',
    'userid',
    'title',
    'description',
    'price',
    'url',
    'originalUrl',
    'image',
    'dateCreated',
    'interestid',
    'deactivated',
    'sortorder',
    'featured',
    'what_text',
    'why_text',
    'who_text',
    'short_description',
    'brand_id',
];
